export default __webpack_public_path__ + "f679bf5d47be902cf47545f63623017a.svg";